import StepCompleted from "./StepCompleted";

export default StepCompleted;
